import React,{useState,useEffect,useRef} from "react";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { getAllMilestonesBySubCourseId } from "../../../store/actions/CreateContent/OrganizeAPI/SubCoursesAPIs";

import BatchSections from "./BatchSections";

import BatchLeftPopup from "./BatchLeftPopup";
import { getDripItem } from "./getDripItem";
import { CalendarFold, ChevronDown, ChevronUp } from "lucide-react";


const BatchMilestones =({selectCoursePopUp,SubCourseData,setOpenMilestoneForSubCourse,setCreateNewMileStone,contentDripArr})=>{

     const dispatch = useDispatch();
         const user = useSelector((state)=>state?.user?.user);
               const [activeFilterOne, setActiveFilterOne] =useState(true);
                       const [activeFilterTwo, setActiveFilterTwo] =useState(true);
                       const [activeFilterThree, setActiveFilterThree] =useState(false);
                       const [activeFilterFour, setActiveFilterFour] =useState(false);
                       const [activeFilterASC, setActiveFilterASC] =useState(true);
                       const [activeFilterDESC, setActiveFilterDESC] =useState(false);
                       const [createNewMileStoneStatus, setCreateNewMileStoneStatus] =useState(false);
                       
         const [snackbarVisible, setSnackbarVisible] = useState(false);
                          const [snackbarColor, setSnackbarColor] = useState("#958FDA");
                          const [responseMessage, setResponseMessage] =useState("Something Went Wrong!!!");
                    
                                  const mainMenuStatus = useSelector((state)=>state?.app?.mainMenuStatus);
                       const showSnackbar = () => {
                         setSnackbarVisible(true);
                       };
                      
                       const hideSnackbar = () => {
                         setSnackbarVisible(false);
                       };
                 
                 
                            
                            
                         
                        const [animate, setAnimate] = useState(false);
          
           const [loader , setLoader] =useState({status:true});
    const handleMouseEnter = (CursorTextBg,CursorTextColor,CursorText) =>
        {
          
          dispatch({type: "CURSOR",payload:true  });
      
          dispatch({type: "CURSORTEXT",payload:CursorText})
          dispatch({type: "CURSORTEXTBG",payload:CursorTextBg})
          dispatch({type: "CURSORTEXTCOLOR",payload:CursorTextColor})
        }
         
        const handleMouseLeave = () => {
          
          dispatch({type: "CURSOR",payload:false})
      
          dispatch({type: "CURSORTEXT",payload:""})
      
          dispatch({type: "CURSORTEXTBG",payload:""})
          dispatch({type: "CURSORTEXTCOLOR",payload:""})
        
      
      }
      const [openAppDesignPopUp,setopenAppDesignPopUp]  = useState(false);
      const [openAppDesignPopUpInnerContent,setopenAppDesignPopUpInnerContent]  = useState("appThemes");

      const [currentItem, setCurrentItem] = useState("");
                       const [currentDripItem, setCurrentDripItem] = useState("");
const token = useSelector((state)=>state?.course?.course?.token);
       const currentToken = useSelector((state)=>state?.user?.user?.token);
       const user_email = useSelector((state)=>state?.user?.user?.user_email
      );
      
      const postIdCourse = useSelector((state)=>state?.course?.course?.postId);
      
      const courseData = useSelector((state)=>state?.course?.course);
      
      const AppToken = useSelector((state)=>state?.app?.app?.AppToken);
     
             const appId = useSelector((state)=>state?.app?.app?.ID);
             const appAllottedToken = useSelector((state)=>state?.app?.app?.appAllottedToken);
               
             const [currentDripItemStatus,setCurrentDripItemStatus]=useState(true)
      const scrollRef = useRef(null);
           const [visibility,setVisibility] =useState("public");
           const [orderBy,setOrderBy] =useState("ASC");
           const [itemArr, setItemArr] = useState([]);
           const [itemReorderArr, setItemReorderArr] = useState([]);
           const [itemId, setItemId] = useState("");
           const [deleteSubCoursePopUp, setDeleteSubCoursePopUp] = useState(false);
           const [itemArrLoading, setItemArrLoading] = useState([{},{},{},{},{}]);
           const [openContentInFolder, setOpenContentInFolder] = useState("");
           
 const [subCourseItem ,setSubCourseItem] =useState({});
 const [mileStoneItem ,setMileStoneItem] =useState({});
 const [mileStoneSection ,setMileStoneSection] =useState({});
 const [sectionName ,setSectionName] =useState("");
 const [newSectionPopUp ,setNewSectionPopUp] =useState(false);
 



      useEffect((e)=>{
      
        fireGetAllMilestonesBySubCourseId();
        },[visibility,postIdCourse]);
  const fireGetAllMilestonesBySubCourseId=()=>{
          setItemArr([])
         
        
          setItemArrLoading([{},{},{},{},{}])
        // Popup When Course is not selected
          if(courseData){}else{selectCoursePopUp(true);}
        
        setLoader({status:true});
            // console.log({
            //     token:AppToken,courseId:postIdCourse ,postParent:SubCourseData?.ID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
            //     appToken:AppToken,visibility:visibility,orderBy:orderBy
            //     });
              const apiData = dispatch(getAllMilestonesBySubCourseId({
                token:AppToken,courseId:postIdCourse ,postParent:SubCourseData?.ID,userEmail:user_email?user_email:"",currentToken:currentToken?currentToken:"",
                appToken:AppToken,visibility:visibility,orderBy:orderBy,appId:appId,appAllottedToken:appAllottedToken
                }));
              /* get response as Promise   */
              apiData.then(response => {
                // console.log(response)
        
                if(response){
                 
                  if(response){
                setResponseMessage(response?.message);
                setSnackbarColor("rgba(144, 202, 249,1)");
              
                if(response?.mileStones)  {setItemArr(response?.mileStones); 
                  
                  if(!createNewMileStoneStatus){setMileStoneSection(response?.mileStones[0])}
                  if(createNewMileStoneStatus){setVisibility('public');setMileStoneItem(null); setopenAppDesignPopUp(true);setopenAppDesignPopUpInnerContent("createMileStone");}
      
                  const reorderArray = response?.mileStones.map(item => ({
                    ID: item.ID,
                    menuOrder: item.menuOrder
                }));
                setItemReorderArr(reorderArray);
                //  console.log(reorderArray)
               
                }else{setItemArr([]);};
                setItemArrLoading([]);
            setLoader({status:false});
            
            // setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
            },1000)
               }else{
            //     setResponseMessage("Something Went Wrong...");
                  
            //     setSnackbarColor("#958FDA");
            //   //  selectCoursePopUp(true);
                
                 
            // setLoader({status:false});
            // setItemArrLoading([{},{},{},{},{}]);
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
               }
                  
                // dispatch({
                //   type: "UPDATE_APP_TOKEN",
                  
                //   payload:response?.course?.AppToken
                // });  
              //  console.log(response?.course);
             
               // 
               if(response?.logout){
                // pop up response?.logoutInfo
                //console.log(response?.logoutInfo)
            
                setResponseMessage("You are Logged Out!!!");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                setTimeout(()=>{
                  dispatch({type:"LOGOUT"});
            
                },3000)
                
              }
            /* resetting Login input Fields */
            
                }else{
                  setResponseMessage("Something Went Wrong...");
                  
                  setSnackbarColor("#958FDA");
                 selectCoursePopUp(true);
                 setItemArrLoading([{},{},{},{},{}]);
                   
              setLoader({status:false});
              
              setSnackbarVisible(true);
              setTimeout(()=>{
                
                setSnackbarVisible(false);
               
                 
              },3000)    }
            
              }).catch(error => {
             
                //popup of error Info
                setResponseMessage("Something Went Wrong...");
                  
                setSnackbarColor("#958FDA");
               selectCoursePopUp(true);
                
                 
            setLoader({status:false});
            
            setSnackbarVisible(true);
            setTimeout(()=>{
              
              setSnackbarVisible(false);
             
               
            },3000)
                console.error(error);
              });
         }

         const flattenedData = itemArr!=[]?Object.values(itemArr):'';
   const flattenedDataLoading = itemArrLoading!=[]?Object.values(itemArrLoading):'';
 

     


  
    return (<>
      
        <div  align="left"  > <div style={{margin:"5px"}} >
       
            <h3 align="left">{flattenedData?.length?"Showing " 
             +(flattenedData?.length):"No Content Found"}
              {activeFilterTwo?flattenedData?.length>1?" Milestones"
             :flattenedData?.length?" Milestone":"":""} in Sub-course {SubCourseData?.menuOrder} 
              
              </h3>
            <div  align="left" className=" " style={{margin:"5px",position:"relative"}}> 
          
            <div  >
          {flattenedData.map((item, index) => (
            <div key={index}   >
       
            <div
             style={{display:"flex",justifyContent:"space-between", margin:"10px",background:"#f1f1f1 ",
              position:"relative",borderRadius:"10px",padding:"10px",flexWrap:"wrap"}} 
          
             
            >  <div  style={{display:"flex",justifyContent:"space-between" }}>
          <div  className="">
                     </div> <div   style={{marginTop:"0px",fontWeight:"999"}}  >
                   <div  className="TitleWithEllipsis" style={{width:"150px",marginTop:"10px",fontWeight:"999"}}  >
                  MileStone {index+1}  
                   </div> 
                  
                     </div>
                   
                   </div>       
                   <div style={{display:"flex",justifyContent:"space-between" ,gap:"20px" }}>     <div align="center" className="" style={{marginTop:"20px"}} >
 <div   className="milestoneButtonInCard"  style={{padding:"5px",border:"3px solid rgba(144, 202, 249,1)",fontSize:"14px",padding:"2px 10px",display:"flex",
            justifyContent:"space-between",alignItems:"center",height:"35px",gap:"5px",
                borderRadius:"5px",cursor:"pointer"}}
  onClick={()=>{setCurrentItem(item);setCurrentDripItem(getDripItem(item?.ID, contentDripArr));
                  setCurrentDripItemStatus(true)}}><CalendarFold size={20} color={"rgba(144, 202, 249,1)"}/>{getDripItem(item?.ID, contentDripArr)?"Update":"Add"} Drip</div></div>  
                   
                    {mileStoneSection?.ID==item?.ID?<div align="center" className="" style={{marginTop:"20px",display:"flex"}} ><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave}
                    style={{cursor:"pointer",color:"rgba(144, 202, 249,1)",background:"#fff",width:"120px",fontSize:"14px",height:"40px"}} 
           onClick={()=>{ setMileStoneSection("");setCreateNewMileStoneStatus(false);}}   className="milestoneButtonInCard" > <ChevronUp strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" 
                     style={{padding:"2px",cursor:"pointer"}}/> <span>Close</span> </div>
           </div>:<div align="center" className="" style={{marginTop:"20px"}} ><div   onMouseEnter={handleMouseEnter}  onMouseLeave={handleMouseLeave}
                    style={{cursor:"pointer",color:"rgba(144, 202, 249,1)",background:"#fff",width:"120px",fontSize:"14px",height:"40px"}} 
           onClick={()=>{ setMileStoneSection(item);setCreateNewMileStoneStatus(true);}}   className="milestoneButtonInCard" ><ChevronDown strokeWidth={2} absoluteStrokeWidth  size={18}  color="rgba(255,114,94,0.7)" 
                                style={{padding:"2px",cursor:"pointer"}}/> <span>Open</span> </div>
           </div>}   
                   </div>  </div> 
                   {mileStoneSection?.ID==item?.ID? <div>    
              <BatchSections contentDripArr={contentDripArr} mileStoneItemSend={mileStoneItem} mileStoneSectionSend={mileStoneSection} setOpenMilestoneForSubCourse={setOpenMilestoneForSubCourse} 
              selectCoursePopUp={selectCoursePopUp} SubCourseData={SubCourseData} index={index}/>
            </div>:""} 
            </div>
          ))}


{flattenedDataLoading?flattenedDataLoading?.map((item, index) => (
  <div key={index} style={{display:"flex",justifyContent:"flex-start", }}    >
       
            <div
className={"scroller-item text-linetw"  }
             style={{ margin:"0px",marginTop:"-5px",
                marginRight:"0px",position:"relative",borderRadius:"10px",overflow:"hidden"}} 
          
             
            >    </div>  </div> )):""} 
      
        </div>
            
            </div>
           
            </div>




           
      
    


 {currentDripItemStatus&&currentItem?.ID?<BatchLeftPopup
       setCurrentDripItemStatus={()=>{ setCurrentDripItemStatus(false)}}
      contentDripArr={contentDripArr}
       currentDripItemStatus={currentDripItemStatus}
      currentItem={currentItem}
        currentDripItem={currentDripItem}
       onClose={()=>{setCurrentDripItem("")}}
        onAdded={()=>{}}
      />:""}

        
        </div></>)
}
export default BatchMilestones;

